// extracted by mini-css-extract-plugin
export var aiStarIcon = "_ks-2";
export var container = "_ks-4";
export var dismissButton = "_ks-3";
export var hasPaddingBottom = "_ks-6";
export var last = "_ks-e";
export var scrollbarThumb = "_ks-c";
export var scrollbarTrack = "_ks-b";
export var selected = "_ks-9";
export var spin = "_ks-1";
export var spinning = "_ks-0";
export var suggestionItem = "_ks-d";
export var suggestionsPanel = "_ks-5";
export var tonePill = "_ks-8";
export var tonesContainer = "_ks-7";
export var unselected = "_ks-a";